.specification-dimensions-popup-content__container {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;

  gap: 24px;

  padding: 8px;
}

.specification-dimensions-popup-content__container .specification-dimensions-popup-content__item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 70px max-content;
  align-items: end;

  gap: 16px;
}

.specification-dimensions-popup-content__container .specification-dimensions-popup-content__measure-units {
  & .ant-select-selector {
    padding: 4px 8px !important;
  }
}

.specification-dimensions-popup-content__container .specification-dimensions-popup-content__button {
  padding: 18px;
}

.specification-dimensions-popup-content__container .specification-dimensions-popup-content__add-button {
  margin-top: 16px;

  width: unset !important;
}
